import { subscribe } from '@wh/message-bus';

const SIDEBAR_NAVIGATION_OPEN = 'sidebarNavigation.open';
const SIDEBAR_NAVIGATION_CLOSE = 'sidebarNavigation.close';

export const sidebarPlugin = {
  afterRender({ updateHeaderProps }) {
    subscribe(SIDEBAR_NAVIGATION_OPEN, () => {
      updateHeaderProps({ hamburgerState: 'active', shifted: true });
    });
    subscribe(SIDEBAR_NAVIGATION_CLOSE, () => {
      updateHeaderProps({ hamburgerState: 'inactive', shifted: false });
    });
  },
};
